var _path, _path2, _g, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.334h512v341.337H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 85.334h256v170.663H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 85.329v15.083l57.377 38.251H80z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#2E52B2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 107.951v30.712h46.069zM96 85.331v48.913L22.628 85.331z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M256 85.329v15.083l-57.377 38.251H176z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#2E52B2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 107.951v30.712h-46.069zM160 85.331v48.913l73.372-48.913z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M0 85.329v15.083l57.377 38.251H80z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#2E52B2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 107.951v30.712h46.069zM96 85.331v48.913L22.628 85.331z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M256 85.329v15.083l-57.377 38.251H176z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#2E52B2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 107.951v30.712h-46.069zM160 85.331v48.913l73.372-48.913z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M0 255.997v-15.082l57.377-38.252H80z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#2E52B2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 233.376v-30.713h46.069zM96 255.994v-48.912l-73.372 48.912z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M256 255.997v-15.082l-57.377-38.252H176z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#2E52B2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 233.376v-30.713h-46.069zM160 255.994v-48.912l73.372 48.912z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 170.66,
    r: 22.627
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m128 154.663 3.97 12.222h12.854l-10.398 7.556 3.971 12.222L128 179.109l-10.398 7.554 3.972-12.222-10.398-7.556h12.853zM128 219.803l2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zM128 102.469l2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zM197.931 161.136l2.365 7.277h7.653l-6.192 4.499 2.365 7.279-6.191-4.498-6.191 4.498 2.365-7.279-6.191-4.499h7.652zM58.069 161.136l2.364 7.277h7.653l-6.191 4.499 2.364 7.279-6.19-4.498-6.191 4.498 2.365-7.279-6.192-4.499h7.653z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNu);
export default __webpack_public_path__ + "static/media/NU.1f65bb30.svg";
export { ForwardRef as ReactComponent };